import {BuilderInterface} from "./Main";
import {TodoistSync} from "./TodoistSync";


export interface SectionInterface  {

    getId():number
    getTitle():string

}

export class Section implements SectionInterface{

    private _section: TodoistSync.SectionInterface;

    constructor(section: TodoistSync.SectionInterface){
        this._section = section;
    }


    getId(): number {
        return this._section.id;
    }

    getTitle(): string {
        return this._section.name;
    }

}

export class SectionSingleton {

    private static _instance : SectionInterface;

    private constructor(){

    }

    public static getInstance() :SectionInterface {
        if (SectionSingleton._instance) {
            return SectionSingleton._instance;
        }
        let sectionSync: TodoistSync.SectionInterface;
        sectionSync = {
            collapsed: false,
            date_added: "",
            date_archived: null,
            id: 0,
            is_archived: false,
            is_deleted: false,
            name: "Все зоны",
            project_id: 0,
            section_order: 0,
            user_id:0

        };

        return SectionSingleton._instance = new Section(sectionSync);
    }
}


export class SectionBuilder implements BuilderInterface<TodoistSync.SectionInterface, SectionInterface>{

    constructor(){}

    build(section: TodoistSync.SectionInterface): SectionInterface {

        return  new Section(section);
    }

}

